var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "btn-group", attrs: { "data-toggle": "buttons" } },
        _vm._l(_vm.options, function(option) {
          return _c(
            "label",
            {
              key: option.name,
              staticClass: "btn btn-primary",
              class: { active: option == _vm.currentActiveOption },
              attrs: { disabled: _vm.disabled }
            },
            [
              _c("input", {
                ref: "option.name",
                refInFor: true,
                staticClass: "btn btn-primary",
                class: { disabled: _vm.disabled },
                attrs: {
                  disabled: _vm.disabled,
                  type: "radio",
                  autocomplete: "off",
                  checked: ""
                },
                on: {
                  click: function($event) {
                    return _vm.setToggle(option)
                  }
                }
              }),
              _vm._v("\n      " + _vm._s(option.name) + "\n    ")
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }